import React from 'react'
import { observer } from 'mobx-react'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetSection,
} from 'components/ModalSheet'
import Button from 'components/Button'
import {
  Form,
  FormGroupContainer,
  FormRow,
  TextInputContainer,
} from 'components/inputs'
import { SingleItemSelector } from 'admin/staffing/components/WorkspacePostingDialog/SingleItemSelector'
import Avatar from 'components/Avatar'
import { CallCenterAddClientDialogViewModel } from './CallCenterAddClientDialogViewModel'

interface AddClientDialogProps {
  vm: CallCenterAddClientDialogViewModel
}

export default observer(function AddClientDialog({ vm }: AddClientDialogProps) {
  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetSection spaced>
          <ModalSheetContentTitle>Create client</ModalSheetContentTitle>
          <Form id="callCenterAddClient" onSubmit={vm.submit}>
            <FormRow>
              <FormGroupContainer
                label="Email"
                error={vm.validation.getError('email')}
              >
                <TextInputContainer
                  model={vm}
                  field="email"
                  placeholder="client@example.com"
                  name="email"
                  autoComplete="email"
                />
              </FormGroupContainer>
            </FormRow>
            <FormRow>
              <FormGroupContainer
                label="First name"
                error={vm.validation.getError('firstName')}
              >
                <TextInputContainer
                  model={vm}
                  field="firstName"
                  placeholder="Jane"
                  name="firstName"
                  autoComplete="given-name"
                />
              </FormGroupContainer>
            </FormRow>
            <FormRow>
              <FormGroupContainer
                label="Last name"
                error={vm.validation.getError('lastName')}
              >
                <TextInputContainer
                  model={vm}
                  field="lastName"
                  placeholder="Doe"
                  name="lastName"
                  autoComplete="family-name"
                />
              </FormGroupContainer>
            </FormRow>
            <FormRow>
              <FormGroupContainer
                label="Phone"
                error={vm.validation.getError('phone')}
              >
                <TextInputContainer
                  model={vm}
                  field="phone"
                  placeholder="(555) 123-4567"
                  name="phone"
                  autoComplete="tel"
                />
              </FormGroupContainer>
            </FormRow>
            <FormRow>
              <FormGroupContainer
                label="Workspace"
                error={vm.validation.getError('selectedWorkspace')}
              >
                <SingleItemSelector
                  model={vm.selectedWorkspace ?? undefined}
                  placeholder="Select workspace"
                  onChange={(workspace) =>
                    vm.setWorkspace(workspace === undefined ? null : workspace)
                  }
                  itemOptions={vm.availableWorkspaces}
                  itemPrefix={(workspace) =>
                    workspace ? (
                      <Avatar
                        size={24}
                        subject={{ avatar: workspace.branding.logos.icon }}
                      />
                    ) : undefined
                  }
                  itemToString={(workspace) => workspace?.name || ''}
                />
              </FormGroupContainer>
            </FormRow>
          </Form>
        </ModalSheetSection>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button type="default" onClick={vm.close}>
            Cancel
          </Button>
          <Button
            type="primary"
            submit
            form="callCenterAddClient"
            loading={vm.submit.pending}
            disabled={vm.submit.pending}
          >
            Create client
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
